module.exports = __webpack_public_path__ + "img/Avatar.63917d4c.svg";